import { render, staticRenderFns } from "./TaskExistingCustomFields.vue?vue&type=template&id=56faf379&"
import script from "./TaskExistingCustomFields.vue?vue&type=script&lang=js&"
export * from "./TaskExistingCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports